import { Component } from '@angular/core';
import { DashboardService } from '@flyfreely-portal-ui/flyfreely';
import { WidgetStatus } from '@flyfreely-portal-ui/widget';
import {
    CurrentOrganisation,
    LoadingOrganisations,
    WorkspaceStateService
} from '@flyfreely-portal-ui/workspace';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { OutstandingTasksViewService } from '../../outstanding-tasks-view.service';

@Component({
    selector: 'flyfreely-portal-ui-outstanding-tasks-sidebar',
    templateUrl: './outstanding-tasks-sidebar.component.html',
    styleUrls: ['./outstanding-tasks-sidebar.component.scss']
})
export class OutstandingTasksSidebarComponent {
    currentOrganisation: CurrentOrganisation | LoadingOrganisations = {
        type: 'loading'
    };

    selectedWidgets = {
        onboardingTasks: true,
        generalTasks: true,
        profile: true,
        operations: true,
        resources: true,
        organisation: true
    };

    visibleSections = {
        onboardingTasks: false,
        generalTasks: false,
        profile: false,
        operations: false,
        resources: false,
        organisation: false
    };

    private ngUnsubscribe$ = new Subject<void>();
    constructor(
        private sharedService: WorkspaceStateService,
        private outstandingViewService: OutstandingTasksViewService,
        public dashboardService: DashboardService
    ) {}

    ngOnInit() {
        this.sharedService.currentOrganisation$
            .pipe(
                filter(o => o.type === 'organisation_loaded'),
                takeUntil(this.ngUnsubscribe$)
            )
            .subscribe(organisation => {
                this.currentOrganisation = organisation;
            });

        this.outstandingViewService.availableTestWidgets$
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(widgets => {
                if (widgets != null) {
                    this.findVisibleSections(widgets);
                }
            });
    }

    ngOnDestroy() {
        this.ngUnsubscribe$.next();
        this.ngUnsubscribe$.complete();
    }

    private findVisibleSections(availableWidgets: WidgetStatus) {
        const [
            onboardingTasksWidgets,
            generalTasksWidgets,
            personalProfileWidgets,
            operationsWidgets,
            resourcesWidgets,
            organisationWidgets
        ] = this.outstandingViewService.splitWidgetsBySection(availableWidgets);
        this.visibleSections = {
            onboardingTasks: onboardingTasksWidgets.length > 0,
            generalTasks: generalTasksWidgets.length > 0,
            profile: personalProfileWidgets.length > 0,
            operations: operationsWidgets.length > 0,
            resources: resourcesWidgets.length > 0,
            organisation: organisationWidgets.length > 0
        };
    }

    public scrollTo(sectionName: string) {
        this.outstandingViewService.scrollTo(sectionName);
    }

    onMenuChanged() {
        this.outstandingViewService.updateSelectedSections(
            this.selectedWidgets
        );
    }
}
